<template>
  <v-container
    id="listing"
    class="mt-3"
    fluid
  >
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-row v-if="errorMessage">
      <v-col
        cols="12"
      >
        <v-container
          id="listing-div"
        >
          <v-row>
            <v-col
              cols="10"
              class="white-buttons"
            >
              <v-btn
                text
                :href="'/listings?address='+query"
                class="no-deco"
              >
                <v-icon>
                  {{ 'mdi-keyboard-backspace' }}
                </v-icon>
                Search
              </v-btn>
              <h2
                v-if="errorAddress"
                class="mt-3"
              >
                {{ errorAddress }}
              </h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
            >
              <p
                class="listings-error"
              >
                {{ errorMessage }}
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row v-if="listing">
      <v-col
        cols="12"
      >
        <v-container
          id="listing-div"
        >
          <v-row>
            <v-col
              cols="12"
              class="white-buttons d-flex justify-space-between align-center px-0 flex-wrap"
              style="margin-top: 7px"
            >
              <!-- router-link :to="{ name: 'Listings', query: { address: query }}" -->
              <div class="white-buttons-container flex-wrap">
                <v-btn
                  text
                  :href="'/listings?address='+query"
                  class="no-deco"
                >
                  <v-icon>
                    {{ 'mdi-keyboard-backspace' }}
                  </v-icon>
                  Search
                </v-btn>
                <!-- /router-link -->
                <v-btn
                  outlined
                  text
                  @click="scrollTo('overview', 'offset: 200')"
                >
                  Overview
                </v-btn>
                <v-btn
                  outlined
                  text
                  @click="scrollTo('public-info')"
                >
                  Public Info
                </v-btn>
                <v-btn
                  outlined
                  text
                  @click="scrollTo('property-details')"
                >
                  Property Details
                </v-btn>
                <v-btn
                  outlined
                  text
                  @click="scrollTo('sales-tax-history')"
                >
                  Sale & Tax History
                </v-btn>
                <v-btn
                  outlined
                  text
                  @click="scrollTo('schools')"
                >
                  Schools
                </v-btn>
                <h2
                  id="overview"
                  class="mt-3"
                >
                <!-- {{ listing.address.street_number }}
                {{ listing.address.street_name }}
                {{ listing.address.street_suffix }},
                {{ listing.address.city }},
                {{ listing.address.state }}
                {{ listing.address.zip_code }} -->
                <!-- {{ listing.address.full_address }} -->
                <!-- v-btn
                  text
                  :href="'/listings?address='+query"
                  class="no-deco"
                >
                  <v-icon>
                    {{ 'mdi-flag-variant-outline' }}
                  </v-icon>
                  Sponsor This Listing
                </!-->
                </h2>
                <v-btn
                  v-if="isRealtor && !isSponsored"
                  class="mr-2 sponsor-btn pl-sm-0"
                  small
                  elevation="0"
                  @click="sponsorListing"
                >
                  <v-icon>
                    mdi-flag-variant-outline
                  </v-icon>
                  Sponsor This Listing
                </v-btn>
              </div>
              <span
              v-if="forecast && forecast.zipcode !== null"
              class="top-smart-search-btn"
              >
                <router-link :to="{ name: 'Smart Search For Property', params: { property_id: property_id }}">
                  <v-btn
                    x-large
                    elevation="6"
                    class="btn-forecast"
                  >
                    View Smart Search <i class="fas fa-angle-right" />
                  </v-btn>
                </router-link>
              </span>
              <!-- <span
              v-else
              class="top-smart-search-btn"
              >
              <v-btn
                    x-large
                    elevation="6"
                    class="btn-forecast"
                  >
                    View Smart Search <i class="fas fa-angle-right" />
                  </v-btn>
              </span> -->
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="text-center view-smart-search"
            >
              <!-- <v-btn
                text
                elevation="3"
                @click="toggleFavorite(listing)"
              >
                <template
                  v-if="!isFavorite(listing)"
                >
                Add to Favorites
                  <v-icon>mdi-heart-outline</v-icon>
                </template>
                <template v-else>
                  Remove from Favorites
                  <v-icon>mdi-heart</v-icon>
                </template>
              </v-btn> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="mt-0 pt-0"
            >
              <!-- <v-carousel
                v-if="listing.images"
                :show-arrows="false"
              >
                <v-carousel-item
                  v-for="(item,i) in listing.images"
                  :key="i"
                  :src="'/api/v1/sponsored-listing-image/'+listing.sponsored_listing_id+'/'+item"
                />
              </v-carousel> -->
              <v-carousel
                :show-arrows="true"
                v-if="listing.images"
                style="border: solid green;height: 100%;border-width: thin;border-radius: 5px"
              >
                <v-carousel-item
                  v-for="(item,i) in listing.images"
                  :key="i"
                  :src="item"
                />
              </v-carousel>
              <v-img
                v-if="listing.image && !listing.images && listing.image !== placeHolder"
                :src="listing.image"
                aspect-ratio="1.8"
                style="border: solid green;height: 100%;border-width: thin;border-radius: 5px"
              />
              <v-img
                v-if="listing.image && !listing.images && listing.image === placeHolder"
                :src="listing.image"
                style="border: solid green;height: 100%;border-width: thin;border-radius: 5px"
                contain
              />
              <!-- <v-img
                v-if="!listing.image"
                :src="pikachu"
                style="border: solid green;height: 100%;border-width: thin;border-radius: 5px"
                contain
              /> -->
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="mt-0 pt-0"
              style="padding-left: 0;padding-right: 0;"
            >
              <forecast-card
                :displayaddress="listing.address.formatted_street_address"
                :forecast="forecast"
                :user="user"
                style="height: 100%;"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="mt-0 pt-0"
            >
              <v-card
                id="listing-overview-card"
                class="mx-auto listing-overview pa-4"
                light
                outlined
                style="height: 100%;"
              >
                <div class="homecontainer">
                  <!-- <router-link :to="{ name: 'Forecast Tool For Property', params: { fips: fips, apn: apn }}"> -->
                  <!-- <router-link :to="{ name: 'Smart Search For Property', params: { property_id: property_id }}">
                    <v-btn
                      x-large
                      elevation="6"
                      class="btn-forecast"
                    >
                      View Smart Search &gt;
                    </v-btn>
                  </router-link> -->
                  <v-card-title
                    class="card-pricing pa-0"
                  >
                    <!-- <template v-if="((listing.status === 'Active') || (listing.status === 'For Sale') || (listing.status === 'PENDING') || (listing.status === 'Contingent')) && (listing.valuation.list_price)">
                      ${{ formatPrice(listing.valuation.list_price) }}
                      <span class="pricecat">
                        list
                      </span><br>
                    </template> -->
                    <!-- <template v-else-if="listing.valuation.appraisal">
                      ${{ formatPrice(listing.valuation.appraisal) }}
                      <span class="pricecat">
                        appraisal
                      </span><br>
                    </template> -->
                    <div
                      class="price2"
                    >
                      <!-- <img :src='listhubTrackerUrl'>
                      <img
                      v-if="agentOfficeEmailFlag"
                      :src='listhubTrackerUrl2'
                      > -->
                      <div class="property-price-col">
                        <span v-if="listing.valuation.appraisal">${{ formatPrice(listing.valuation.appraisal) }}</span>
                        <span v-else>No Valuation</span>
                        <span
                        class="pricecat"
                        style="margin-left: 5px"
                        >
                          <span v-if="listing.valuation.appraisal">Honely Value Estimate</span>
                          <!-- <span v-else>No Valuation</span> -->
                          <span>
                            <v-tooltip
                              content-class="custom-tooltip"
                              bottom
                              max-width="300px"
                            >
                              <template #activator="{ on, attrs }">
                                <i
                                  :class="'pt-1 mb-5 mdi band-header-icon mdi-information'"
                                  aria-hidden="true"
                                  style="float:right;color:black;"
                                  v-bind="attrs"
                                  v-on="on"
                                />
                              </template>
                              <span>Our proprietary automated valuation model provides the fairest value estimate on the market and quickly adjusts to unusual market conditions.<br><br>Our models have been back tested and verified by a third party to ensure integrity and prevent cherry picking.</span>
                            </v-tooltip>
                          </span>
                        </span>
                      </div>
                      <!-- <span>
                      <router-link :to="{ name: 'Smart Search For Property', params: { property_id: property_id }}">
                    <v-btn
                      x-large
                      elevation="6"
                      class="btn-forecast"
                    >
                      View Smart Search &gt;
                    </v-btn>
                  </router-link>
                  </span> -->
                      <div class="property-option-col">
                        <v-btn
                          text
                          elevation="3"
                          @click="toggleFavorite(listing)"
                        >
                          <template
                            v-if="!isFavorite(listing)"
                          >
                            Add to Favorites
                            <v-icon>mdi-heart-outline</v-icon>
                          </template>
                          <template v-else>
                            Remove from Favorites
                            <v-icon>mdi-heart</v-icon>
                          </template>
                        </v-btn>
                      </div>
                    <!-- <span>
                      <router-link :to="{ name: 'Smart Search For Property', params: { property_id: property_id }}">
                      <v-btn
                        x-large
                        elevation="6"
                        class="btn-forecast"
                      >
                        View Smart Search &gt;
                      </v-btn>
                    </router-link>
                    </span> -->
                    <img :src='listhubTrackerUrl'>
                    <img
                      v-if="agentOfficeEmailFlag"
                      :src='listhubTrackerUrl2'
                    >
                    </div>
                  </v-card-title>
                  <h3
                    class="card-address mt-4"
                    style="margin-top:0px !important;"
                  >
                    {{ listing.address.full_address }}
                    <!-- {{ listing.address.street_number }}
                    {{ listing.address.street_name }}
                    {{ listing.address.street_suffix }},
                    {{ listing.address.city }},
                    {{ listing.address.state }}
                    {{ listing.address.zip_code }} -->
                  </h3>
                  <!-- <br> -->
                  <h3
                  style="margin-top:5px;"
                  >
                    {{ formatCount(listing.structure.beds_count) }}  Beds
                    <span>&bull;</span>
                    {{ formatCount(listing.structure.baths) }}  Baths
                    <span>&bull;</span>
                    {{ getHomeSize(listing.structure.total_area_sq_ft) }} Sq. Ft.
                  </h3>
                  <h3
                  style="margin-top:16px; color: #808080;"
                  >
                    <span style="color: #e67e22;padding-left: 0px;">{{ listing.status }}</span>
                    <!-- <span>&bull;</span> -->
                    <!-- Est. Mortgage $x,xxx/month
                    <span>&bull;</span>
                    Get <a><u>financing</u></a> -->
                    <!-- <span style="color:#808080;">Est. Mortgage $x,xxx/month</span>
                    <span>&bull;</span>
                    <span style="color:#808080;">Get <a><u>financing</u></a></span> -->
                  </h3>
                  <h4> Property Posted On: {{ listing.valuation.date }} </h4>
                  <!-- <h4
                  style="margin-top:16px;"
                  >
                    Listing provided by:
                  </h4>
                  <h3
                  style="margin-top:4px;"
                  ><span style="color: black;padding-left: 0px;">Aviara Real Estate</span>
                  <span>&bull;</span>
                  <span style="color:black;">(999) 999-9999</span>
                  <span>&bull;</span>
                  <span style="color:black;">Kevin Webber</span></h3>
                  <small style="display:inline-block;color:#808080;margin-top:16px">Copyright &copy; 2021 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</small> -->
                  <div
                    class="tool-buttons mt-6"
                  >
                    <v-tooltip bottom>
                      <template #activator="{ on, attrs }">
                        <v-btn
                          class="mr-2"
                          small
                          :href="'https://www.google.com/maps/dir//' + listing.address.full_address"
                          target="_blank"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>
                            mdi-directions
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Get Directions</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template #activator="{ on, attrs }">
                        <v-btn
                          class="mr-2"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>
                            mdi-share
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Share</span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom>
                      <template #activator="{ on, attrs }">
                        <v-btn
                          class="mr-2"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="toggleFavorite(listing)"
                        >
                          <template
                            v-if="!isFavorite(listing)"
                          >
                            <v-icon>mdi-heart-outline</v-icon>
                          </template>
                          <template v-else>
                            <v-icon>mdi-heart</v-icon>
                          </template>
                        </v-btn>
                      </template>
                      <span v-if="!isFavorite(listing)">Add To Favorites</span>
                      <span v-else>Remove From Favorites</span>
                    </v-tooltip> -->
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.name === 'md'"
              id="listing-map"
              cols="12"
              md="6"
              class="map-container mx-auto listing-overview pa-4 v-card v-sheet v-sheet--outlined theme--light"
              style="height: 296px"
            />
            <v-col
              v-else
              id="listing-map"
              cols="12"
              md="6"
              class="map-container mx-auto listing-overview pa-4 v-card v-sheet v-sheet--outlined theme--light"
              style="height: 288px"
            />
          </v-row>
          <!-- <v-row>
            <v-col
            cols="12"
            >
                  <span style="display:inline-block;color:#808080;margin-top:2px; font-size:15px">Listing provided by:</span><br>
                  <span style="display:inline-block;color:#808080;margin-top:2px; font-size:15px">Aviara Real Estate</span><br>
                  <span style="display:inline-block;color:#808080;margin-top:2px; font-size:15px">(999) 999-9999</span><br>
                  <span style="display:inline-block;color:#808080;margin-top:2px; font-size:15px">Kevin Webber</span><br>
                  <small style="display:inline-block;color:#808080;margin-top:16px">Copyright &copy; 2021 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</small>
            </v-col>
          </v-row> -->
        </v-container>
      </v-col>
    </v-row>
    <v-row
      v-if="listing && listing.list_agent_information"
      id="property-details"
    >
      <v-col
        class="background-gray"
      >
        <v-container
          id="listing-div"
          class="pb-8"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
              class="white-buttons"
            >
              <base-heading
                class="mt-0 band-header pb-1"
                title=""
                weight="medium"
                size="text-h5"
                space="1"
              >
                <span>
                <!-- 1. -->
                <i
                  class="mdi mdi-home"
                  aria-hidden="true"
                />
              </span>
                Questions about this property?
              </base-heading>
              <v-row>
                <v-col
                  cols="8"
                >
                Get immediate information from a knowledgeable buyer's agent.
                <v-form>
                  <v-text-field
                  v-model="leadName"
                  placeholder="Your Name"
                  :maxlength="60"
                  />
                  <v-text-field
                  v-model="leadPhone"
                  placeholder="Phone"
                  :rules="phoneRules"
                  @keypress="isNumber($event)"
                  :maxlength="10"
                  />
                  <v-text-field
                  v-model="leadEmail"
                  :rules="emailRules"
                  :maxlength="50"
                  placeholder="Email"
                  />
                  <v-text-field
                  v-model="leadMessage"
                  placeholder="Message"
                  :maxlength="200"
                  />
                  <br>
                  <p>By proceeding, you consent to receive calls, text and voicemails at the number you provided (may be recorded and may be autodialed and use pre-recorded and artificial voices), and email, from HousesFor.Sale, Opcity, realtor.com and their network of service providers about your inquiry and other hone related matters. Msg/data rates may apply. This consent applies even if you are on a do not call list can is not a contain of any purchase.</p>
                  <v-btn
                    v-if="!leadFormErrorMessage && !successMessage"
                    @click="submitLead()"
                    color="primary"
                    class="login-button"
                  >
                    Contact Now
                  </v-btn>
                  <p
                  v-if="leadFormErrorMessage"
                  style="color: red"
                  >{{ leadFormErrorMessage }}</p>
                  <p
                  v-if="successMessage"
                  style="color: green"
                  >{{ successMessage }}</p>
                </v-form>
                </v-col>
                <v-col
                cols="4"
                style="padding-left:7%"
                >
                <v-row
                style="margin-top:1px;"
                >
                  <v-col
                  cols="12"
                  >
                  <v-avatar
                        class="mx-auto"
                        rounded
                        color="grey"
                        size="150"
                      >
                        <v-img src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg" />
                      </v-avatar>
                  </v-col>
                  <v-col
                  cols="8"
                  >
                  <h3>{{ listing.list_agent_information.list_agent_full_name }}</h3>
                  <p>{{ listing.list_agent_information.list_office_name }}<p>
                  <h3>{{ listing.list_agent_information.list_agent_preferred_phone }}</h3>
                  <!-- Call anytime
                  <p>8am - 10pm, 7 days a week</p> -->
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col
                  cols="12"
                  >
                  <h3>Agent Wilson</h3>
                  <p>OpCity</p>
                  <h3>(999) 999-9999</h3>
                  Call anytime
                  <p>8am - 10pm, 7 days a week</p>
                  </v-col>
                </v-row> -->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <!-- <v-row
      v-if="listing"
      id="property-details"
    >
      <v-col
        class="background-white"
      >
        <v-container
          id="listing-div"
          class="pb-8"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
              class="white-buttons"
            >
              <base-heading
                class="mt-0 band-header pb-1"
                title=""
                weight="medium"
                size="text-h5"
                space="1"
              >
                <span> -->
                <!-- 1. -->
                <!-- <i
                  class="mdi mdi-home"
                  aria-hidden="true"
                />
              </span>
                Description
              </base-heading>
              <v-row>
                <v-col
                  cols="12"
                >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row> -->
    <v-row
      v-if="listing && listing.structure.media_url"
      id="property-details"
    >
      <v-col
        class="background-white"
      >
        <v-container
          id="listing-div"
          class="pb-8"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
              class="white-buttons"
            >
              <base-heading
                class="mt-0 band-header pb-1"
                title=""
                weight="medium"
                size="text-h5"
                space="1"
              >
                <span>
                <!-- 1. -->
                <i
                  class="mdi mdi-home"
                  aria-hidden="true"
                />
              </span>
                <a :href="listing.structure.media_url">Virtual Tour</a>
              </base-heading>
              <v-row>
                <v-col
                  cols="12"
                >
                <!-- <div
                class="container"
                > -->
                <div>
                <iframe
                  :src="listing.structure.media_url"
                  width="100%"
                  height="800px"
                  frameborder="0"
                >
                </iframe>
                </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row
      v-if="listing"
      id="public-info"
    >
      <v-col
        class="background-white"
      >
        <v-container
          id="listing-div"
          class="pb-8"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
              class="white-buttons"
            >
              <base-heading
                class="mt-0 band-header pb-1"
                title=""
                weight="medium"
                size="text-h5"
                space="1"
              >
                <span>
                <!-- 1. -->
                <i
                  class="mdi mdi-home"
                  aria-hidden="true"
                />
                </span>
                Public Info
                <v-btn
                  v-if="isMySponsor"
                  x-large
                  elevation="6"
                  class="btn-forecast btn-squash header-btn"
                  @click="editListingInfo"
                >
                  <v-icon left>
                    mdi-pencil
                  </v-icon>
                  Edit Property Info
                </v-btn>
              </base-heading>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <table
                    class="mt-3 lined-table"
                  >
                    <tr v-if="listing.address.unit_type">
                      <td>
                        Property Type
                      </td>
                      <td>
                        {{ listing.address.unit_type }}
                      </td>
                    </tr>
                    <tr v-if="listing.structure.beds_count">
                      <td>
                        Beds
                      </td>
                      <td>
                        {{ formatCount(listing.structure.beds_count) }}
                      </td>
                    </tr>
                    <tr v-if="listing.structure.baths">
                      <td>
                        Baths
                      </td>
                      <td>
                        {{ formatCount(listing.structure.baths) }}
                      </td>
                    </tr>
                    <tr v-if="listing.structure.total_area_sq_ft">
                      <td>
                        Sq. Ft.
                      </td>
                      <td>
                        {{ getHomeSize(listing.structure.total_area_sq_ft) }}
                      </td>
                    </tr>
                  </table>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <table
                    class="mt-3 lined-table"
                  >
                    <tr v-if="listing.structure.stories">
                      <td>
                        Stories
                      </td>
                      <td>
                        {{ listing.structure.stories }}
                      </td>
                    </tr>
                    <tr v-if="listing.structure.architecture_type">
                      <td>
                        Style
                      </td>
                      <td>
                        {{ listing.structure.architecture_type }}
                      </td>
                    </tr>
                    <tr v-if="listing.structure.year_built">
                      <td>
                        Year Built
                      </td>
                      <td>
                        {{ listing.structure.year_built }}
                      </td>
                    </tr>
                    <tr v-if="listing.address.fips">
                      <td>
                        County code
                      </td>
                      <td>
                        {{ listing.address.fips }}
                      </td>
                    </tr>
                    <!-- <tr>
                      <td>
                        Days on site
                      </td>
                      <td>
                        xx
                      </td>
                    </tr> -->
                    <!-- <tr v-if="listing.address.apn">
                      <td>
                        APN
                      </td>
                      <td>
                        {{ listing.address.apn }}
                      </td>
                    </tr> -->
                  </table>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="white-buttons pl-10 justify-center sidebar"
            >
              <template
                v-if="isRealtor && !isSponsored"
              >
                <base-heading
                  class="mt-1 pb-1 sidebar-heading"
                  title=""
                  weight="medium"
                  size="text-h5"
                  space="1"
                  align="center"
                >
                  Are you a real estate professional?
                </base-heading>
                <p>
                  Non voluptate ex elit nisi sit occaecat reprehenderit nostrud id exercitation.
                  Ex do culpa fugiat nulla voluptate ut adipisicing.
                </p>
                <v-btn
                  medium
                  elevation="6"
                  @click="sponsorListing"
                >
                  <v-icon left>
                    mdi-flag-variant-outline
                  </v-icon>
                  Sponsor This Listing
                </v-btn>
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row
      v-if="listing"
      id="property-details"
    >
      <v-col
        class="background-gray"
      >
        <v-container
          id="listing-div"
          class="pb-8"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
              class="white-buttons"
            >
              <base-heading
                class="mt-0 band-header pb-1"
                title=""
                weight="medium"
                size="text-h5"
                space="1"
              >
                <span>
                <!-- 1. -->
                <i
                  class="mdi mdi-home"
                  aria-hidden="true"
                />
               </span>
                Property Details for
                {{ listing.address.street_number }}
                {{ listing.address.street_name }}
              </base-heading>
              <v-row>
                <v-col
                  cols="12"
                >
                  <table
                    class="mt-3"
                  >
                    <tr>
                      <th>
                        Interior Features
                      </th>
                    </tr>
                    <tr>
                      <td>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <table
                              class="mt-3 lined-table"
                            >
                              <!-- <tr>
                                <th
                                  colspan="2"
                                >
                                  Bed &amp; Bath
                                </th>
                              </tr>
                              <tr v-if="listing.structure.beds_count">
                                <td>
                                  # of Bedrooms
                                </td>
                                <td>
                                  {{ formatCount(listing.structure.beds_count) }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.baths">
                                <td>
                                  # of Full Baths
                                </td>
                                <td>
                                  {{ formatCount(listing.structure.baths) }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.partial_baths_count">
                                <td>
                                  # of Partial Baths
                                </td>
                                <td>
                                  {{ formatCount(listing.structure.partial_baths_count) }}
                                </td>
                              </tr> -->
                              <tr>
                                <th
                                  colspan="2"
                                  class="table-subspacer"
                                >
                                  Room Information
                                </th>
                              </tr>
                              <!-- <tr v-if="listing.structure.rooms_count"> -->
                              <tr>
                                <td>
                                  Room Count
                                </td>
                                <td>
                                  {{ formatCount(listing.structure.rooms_count) }}
                                </td>
                              </tr>
                              <!-- <tr v-if="listing.structure.other_rooms"> -->
                              <tr>
                                <td>
                                  Other Rooms
                                </td>
                                <td>
                                  {{ formatCount(listing.structure.other_rooms) }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.air_conditioning_type || listing.structure.heating_type">
                                <th
                                  colspan="2"
                                  class="table-subspacer"
                                >
                                  Heating &amp; Cooling
                                </th>
                              </tr>
                              <tr v-if="listing.structure.air_conditioning_type">
                                <td>
                                  Air Conditioning Type
                                </td>
                                <td>
                                  {{ listing.structure.air_conditioning_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <!-- <tr v-if="listing.structure.air_conditioning_type"> -->
                              <tr
                              v-if="listing.structure.heating_type"
                              >
                                <td>
                                  Heating Type
                                </td>
                                <td>
                                  {{ listing.structure.heating_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <!-- <tr v-if="listing.structure.heating_fuel_type"> -->
                              <tr
                              v-if="listing.structure.heating_fuel_type"
                              >
                                <td>
                                  Heating Fuel Type
                                </td>
                                <td>
                                  {{ listing.structure.heating_fuel_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                            </table>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <table
                              class="mt-3 lined-table"
                            >
                              <tr>
                                <th
                                  colspan="2"
                                >
                                  Additional Details
                                </th>
                              </tr>
                              <tr v-if="listing.structure.stories">
                                <td>
                                  Stories
                                </td>
                                <td>
                                  {{ listing.structure.stories.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.amenities">
                                <td>
                                  Amenities
                                </td>
                                <td>
                                  {{ listing.structure.amenities.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.total_area_sq_ft">
                                <td>
                                  Lot size
                                </td>
                                <td>
                                  {{ getLotSize(listing.structure.total_area_sq_ft) }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.parking_type">
                                <td>
                                  Parking Type
                                </td>
                                <td>
                                  {{ listing.structure.parking_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.parking_spaces_count">
                                <td>
                                  Parking Spaces Count
                                </td>
                                <td>
                                  {{ listing.structure.parking_spaces_count.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.plumbing_fixtures_count">
                                <td>
                                  Plumbing Fxtures Count
                                </td>
                                <td>
                                  {{ listing.structure.plumbing_fixtures_count }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.pool_type">
                                <td>
                                  Pool
                                </td>
                                <td v-if="listing.structure.pool_type === true">
                                  Yes
                                </td>
                                <td v-else-if="listing.structure.pool_type === false">
                                  No
                                </td>
                                <td v-else>
                                  {{ listing.structure.pool_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.pool_type">
                                <td>
                                  Spa
                                </td>
                                <td v-if="listing.structure.spa === true">
                                  Yes
                                </td>
                                <td v-else-if="listing.structure.spa === false">
                                  No
                                </td>
                                <td v-else>
                                  {{ listing.structure.spa }}
                                </td>
                              </tr>
                            </table>
                          </v-col>
                        </v-row>
                      </td>
                    </tr>
                  </table>
                  <table
                    class="mt-3"
                  >
                    <tr>
                      <th>
                        Construction &amp; Exterior Features
                      </th>
                    </tr>
                    <tr>
                      <td>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <table
                              class="mt-3 lined-table"
                            >
                              <tr>
                                <th
                                  colspan="2"
                                >
                                  Building Information
                                </th>
                              </tr>
                              <tr v-if="listing.structure.year_built">
                                <td>
                                  Year Built
                                </td>
                                <td>
                                  {{ listing.structure.year_built }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.units_count">
                                <td>
                                  Units Count
                                </td>
                                <td>
                                  {{ listing.structure.units_count }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.architecture_type">
                                <td>
                                  Architecture Type
                                </td>
                                <td>
                                  {{ listing.structure.architecture_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.condition">
                                <td>
                                  Condition
                                </td>
                                <td>
                                  {{ listing.structure.condition.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.exterior_features">
                                <td>
                                  Exterior Features
                                </td>
                                <td>
                                  {{ listing.structure.exterior_features.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  colspan="2"
                                  class="table-subspacer"
                                >
                                  Walls &amp; Flooring
                                </th>
                              </tr>
                              <tr v-if="listing.structure.exterior_wall_type">
                                <td>
                                  Exterior Walls
                                </td>
                                <td>
                                  {{ listing.structure.exterior_wall_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.interior_wall_type">
                                <td>
                                  Interior Walls
                                </td>
                                <td>
                                  {{ listing.structure.interior_wall_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.flooring_types">
                                <td>
                                  Flooring Type
                                </td>
                                <td>
                                  {{ listing.structure.flooring_types.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                            </table>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <table
                              class="mt-3 lined-table"
                            >
                              <tr>
                                <th
                                  colspan="2"
                                >
                                  Construction
                                </th>
                              </tr>
                              <tr v-if="listing.structure.basement_type">
                                <td>
                                  Basement Type
                                </td>
                                <td>
                                  {{ listing.structure.basement_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.construction_type">
                                <td>
                                  Construction Type
                                </td>
                                <td>
                                  {{ listing.structure.construction_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.foundation_type">
                                <td>
                                  Foundation Type
                                </td>
                                <td>
                                  {{ listing.structure.foundation_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.roof_style_type">
                                <td>
                                  Roof Style
                                </td>
                                <td>
                                  {{ listing.structure.roof_style_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.roof_material_type">
                                <td>
                                  Roof Material
                                </td>
                                <td>
                                  {{ listing.structure.roof_material_type.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.quality">
                                <td>
                                  Quality
                                </td>
                                <td>
                                  {{ listing.structure.quality.replace(/,(?=[^\s])/g, ", ") }}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  colspan="2"
                                  class="table-subspacer"
                                  v-if="listing.structure.sewer_type || listing.structure.water_type"
                                >
                                  Utilities
                                </th>
                              </tr>
                              <tr v-if="listing.structure.sewer_type">
                                <td>
                                  Sewer Type
                                </td>
                                <td>
                                  {{ listing.structure.sewer_type }}
                                </td>
                              </tr>
                              <tr v-if="listing.structure.water_type">
                                <td>
                                  Water Type
                                </td>
                                <td>
                                  {{ listing.structure.water_type }}
                                </td>
                              </tr>
                            </table>
                          </v-col>
                        </v-row>
                      </td>
                    </tr>
                  </table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row
      v-if="hasTaxAndSalesData"
      id="sales-tax-history"
    >
      <v-col
        class="background-gray"
      >
        <v-container
          id="listing-div"
          class="pb-8"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
              class="white-buttons"
            >
              <tax-history
                :listing="listing"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <!-- <v-row
      v-if="listing"
      id="public-info"
    >
      <v-col
        class="background-gray"
      >
        <v-container
          id="listing-div"
          class="pb-8"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
              class="white-buttons"
            >
              <base-heading
                class="mt-0 band-header pb-1"
                title=""
                weight="medium"
                size="text-h5"
                space="1"
              >
                <span> -->
                <!-- 1. -->
                <!-- <i
                  class="mdi mdi-home"
                  aria-hidden="true"
                />
              </span>
                Local Info
                <v-btn
                  v-if="isMySponsor"
                  x-large
                  elevation="6"
                  class="btn-forecast btn-squash header-btn"
                  @click="editListingInfo"
                >
                  <v-icon left>
                    mdi-pencil
                  </v-icon>
                  Edit Property Info
                </v-btn>
              </base-heading>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <table
                    class="mt-3 lined-table"
                  >
                    <tr>
                      <td>
                        Population
                      </td>
                      <td>
                        xx,xxx
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Graduate Degree Percentile
                      </td>
                      <td>
                        xx.x%
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Households With Children
                      </td>
                      <td>
                        xx.x%
                      </td>
                    </tr>
                  </table>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <table
                    class="mt-3 lined-table"
                  >
                    <tr>
                      <td>
                        Median Household Income
                      </td>
                      <td>
                        $xx,xxx
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Median Homeowner Age
                      </td>
                      <td>
                        xx.x
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Unemployment Rate
                      </td>
                      <td>
                        xx.x%
                      </td>
                    </tr>
                  </table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row> -->
    <v-row
      v-if="listing"
      id="schools"
    >
      <v-col
        class="background-white"
      >
        <v-container
          id="listing-div"
          class="pb-8"
        >
          <v-row>
            <v-col
              cols="12"
              md="8"
              class="white-buttons"
            >
              <base-heading
                class="mt-0 band-header pb-1"
                title=""
                weight="medium"
                size="text-h5"
                space="1"
              >
                <span>
                <!-- 1. -->
                <i
                  class="mdi mdi-home"
                  aria-hidden="true"
                />
              </span>
                Schools
              </base-heading>
              <v-list
                subheader
                two-line
                class="white-background"
              >
                <v-subheader
                  class="listing-subheader"
                >
                  GreatSchools Rating
                </v-subheader>

                <v-list-item
                  v-for="(school,i) in schools"
                  :key="i"
                >
                  <v-list-item-avatar>
                    <v-icon
                      class="grey lighten-1 school-rating"
                      dark
                    >
                      <template v-if="school.rating">
                        {{ school.rating }}/10
                      </template>
                      <template v-else>
                        N/R
                      </template>
                    </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="school.name" />
                    <v-list-item-subtitle v-text="schoolDescription(school)" />
                  </v-list-item-content>

                  <v-list-item-content>
                    <v-list-item-title v-text="school.distance" />
                    <v-list-item-subtitle v-text="school.distanceText" />
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <p
                class="small-type"
              >
                School data provided by
                <a href="http://www.greatschools.org/">
                  GreatSchools
                </a>
                . School service boundaries are intended to be used as reference only. To verify enrollment eligibility for a property, contact the school directly.
              </p>
            </v-col>
            <!-- <v-col
              cols="12"
              md="4"
            >
              <base-heading
                class="mt-0 band-header pb-1"
                title=""
                weight="medium"
                size="text-h5"
                space="1"
              >
                Walk, Bike, &amp; Transit
              </base-heading>
              <v-list
                subheader
                two-line
                class="white-background"
              >
                <v-subheader
                  class="listing-subheader"
                >
                  Ratings from walkscore.com
                </v-subheader>
                <v-list-item
                  v-if="walkscore"
                >
                  <v-list-item-avatar>
                    <v-icon
                      class="grey lighten-1 school-rating"
                      dark
                    >
                      <template v-if="walkscore.walkscore">
                        {{ walkscore.walkscore }}
                      </template>
                      <template v-else>
                        N/R
                      </template>
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Walk Score</v-list-item-title>
                    <v-list-item-subtitle>{{ walkscore.description }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="walkscore && walkscore.bike">
                  <v-list-item-avatar>
                    <v-icon
                      class="grey lighten-1 school-rating"
                      dark
                    >
                      <template v-if="walkscore.bike.score">
                        {{ walkscore.bike.score }}
                      </template>
                      <template v-else>
                        N/R
                      </template>
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Bike Score</v-list-item-title>
                    <v-list-item-subtitle>{{ walkscore.bike.description }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="walkscore && walkscore.transit">
                  <v-list-item-avatar>
                    <v-icon
                      class="grey lighten-1 school-rating"
                      dark
                    >
                      <template v-if="walkscore.transit.score">
                        {{ walkscore.transit.score }}
                      </template>
                      <template v-else>
                        N/R
                      </template>
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Transit Score</v-list-item-title>
                    <v-list-item-subtitle>{{ walkscore.transit.description }}</v-list-item-subtitle>
                    <v-list-item-subtitle
                      class="pt-1"
                    >
                      {{ walkscore.transit.summary }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col> -->
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row
      v-if="listing && listing.broker_information"
      id="property-details"
    >
      <v-col
        class="background-gray"
      >
        <v-container
          id="listing-div"
          class="pb-8"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
              class="white-buttons"
            >
              <base-heading
                class="mt-0 band-header pb-1"
                title=""
                weight="medium"
                size="text-h5"
                space="1"
              >
                <span>
                <!-- 1. -->
                <i
                  class="mdi mdi-home"
                  aria-hidden="true"
                />
              </span>
                Broker Details
              </base-heading>
              <v-row>
                <v-col
                  cols="12"
                >
                <br>
                <div style="padding: 15px; border: 1px solid green; border-radius: 10px; background: white;">
                <h3 style="font-size: 2px0"><u>Listing Provided By:</u></h3>
                <p style="margin-top:16px"><b>Brokerage name:</b> {{ this.toTitleCase(listing.broker_information.list_brokerage_name) }}</p>
                <p v-if="listing.broker_information.list_brokerage_phone"><b>Phone:</b> {{ listing.broker_information.list_brokerage_phone }}</p>
                <p v-if="listing.broker_information.list_brokerage_email"><b>Email ID:</b> {{ listing.broker_information.list_brokerage_email }}</p>
                <p><b>Broker name:</b> {{ this.toTitleCase(listing.broker_information.broker_name) }}</p>
                <p style="font-size: 12px; color: #696969;">{{ listing.list_agent_information.disclaimer }}</p>
                </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row
    v-if="listings.length > 0"
    >
      <v-col
        class="background-gray"
      >
        <v-container
          id="listing-div"
          class="pb-8"
        >
          <v-row>
            <v-col
              cols="12"
              class="white-buttons"
            >
              <v-row
                v-if="listings.length > 0"
                justify="start"
                class="border-me-not"
              >
                <v-col
                  class="intro-text"
                  cols="12"
                  sm="10"
                  md="8"
                >
                  <h1
                    class="mb-1"
                  >
                    Comparable Homes In The Area
                  </h1>
                  <!-- p>
                    You can search for homes that meet your requirements but will also grow in value. Filter by location and specification but also by forecasted growth rates.
                  </! -->
                </v-col>
              </v-row>

              <v-row
                justify="center"
                class="border-me-not"
              >
                <v-col
                  v-for="item in listings"
                  :key="item.property_id"
                  class="intro-text"
                  cols="12"
                  sm="8"
                  md="4"
                >
                  <property-listings-card
                    :item="item"
                  />
                </v-col>
              </v-row>
              <v-row
                justify="center"
                class="border-me-not centeritems"
                align-content="center"
              >
                <v-col
                  cols="12"
                  align-self="center"
                >
                  <!-- base-btn
                    :block="$vuetify.breakpoint.smAndDown"
                    color="white"
                    href="javascript:alert('Load more homes');"
                    large
                    outlined
                    height="40"
                    width="215"
                    class="btn-lightgray mt-3"
                    elevation="3"
                  >
                    Load More
                    <v-icon
                      class="icon-left-space mdi-rotate-90  mdi-20px icon-green"
                    >
                      {{ 'mdi-play' }}
                    </v-icon>
                  </!-->
                </v-col>
              </v-row>
              <!-- <v-row
                justify="center"
                align-content="center"
              >
                <v-col
                  cols="12"
                  align-self="center"
                >
                  <div>
                    <p>lalala</p>
                  </div>
                </v-col>
              </v-row> -->
            </v-col>
          </v-row>
          <!-- <div>
          <p style="color: grey; font-family: 'Avalon Medium', arial; font-size: 15px; margin-botton: 0px">Honely provides the Honely AI, data, website and brand & links "as is," "with all faults" and "as available."</p>
          </div> -->
        </v-container>
      </v-col>
    </v-row>
    <v-row
    v-if="listing"
    >
    <v-col>
          <div>
          <p class="listing-disclaimer">Honely provides the Honely AI, data, website and brand &amp; links &ldquo;as is,&rdquo; &ldquo;with all faults&rdquo; and &ldquo;as available.&rdquo;</p>
          </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  /* eslint-disable */
  import axios from 'axios'
  import Scriptjs from 'scriptjs'
  import { mapGetters, mapState } from 'vuex'
  import { bus } from '@/main'
  import * as constants from '../../components/base64constants'

  /* global google */

  export default {

    components: {
      ForecastCard: () => import('@/components/ForecastCard'),
      PropertyListingsCard: () => import('@/components/PropertyListingsCard'),
      TaxHistory: () => import('@/components/TaxHistory')
    },

    data () {
      return {
        showErrorPage: false,
        agentOfficeEmailFlag: false,
        leadName: null,
        leadPhone: null,
        phoneRules: [
          v => v.length === 10 || 'Phone number must contain 10 digits',
        ],
        leadEmail: null,
        emailRules: [
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        leadMessage: null,
        leadFormErrorMessage: '',
        successMessage: '',
        virtualTourUrl: "https://mk-fresno-photo.seehouseat.com/1920877?idx=1",
        pikachu: "https://listhub-property-images.s3.amazonaws.com/3yd-CCBRSC-21466_1.jpg",
        user: null,
        placeHolder: constants.placeHolder,
        placeHolder2: constants.placeHolder2,
        canSponsorListing: false,
        fips: null,
        apn: null,
        property_id: null,
        listing_key: null,
        query: null,
        mapsKey: 'AIzaSyClIFG-ONBwyXrn4_kaA4yMYHGpZD5EEko',
        listing: null,
        listings: [],
        // eslint-disable-next-line
        listingForDev: {"address":{"fips":"05007","apn":"16-39780-000","street_number":"9","street_pre_direction":"null","street_name":"NORWOOD","street_suffix":"LN","street_post_direction":"null","unit_type":"null","unit_number":"null","formatted_street_address":"9 NORWOOD LN","city":"BELLA VISTA","state":"AR","zip_code":"72714","zip_plus_four_code":"1849","latitude":"36.481077","longitude":"-94.247209","geocoding_accuracy":"PARCEL CENTROID","census_tract":"50070207.012014","carrier_code":"R048","full_address":"9 NORWOOD LN BELLA VISTA AR 72714 1849"},"tax":{"year":"2020","amount":"1263","exemptions":"HOMESTEAD","rate_code_area":"CBV6"},"valuation":{"year":"149000","amount":"125160","exemptions":"172840","forecast_standard_deviation":"16","date":"2021-03-03"},"structure":{"year_built":"null","effective_year_built":"null","stories":"1","rooms_count":"null","beds_count":"3","baths":"2","partial_baths_count":"null","units_count":"null","total_area_sq_ft":"1296.0","air_conditioning_type":"CENTRAL","amenities":"null","architecture_type":"null","basement_type":"null","condition":"null","construction_type":"FRAME","exterior_wall_type":"WOOD","flooring_types":"CARPET|TILE","foundation_type":"PIERS","heating_type":"CENTRAL","heating_fuel_type":"null","interior_wall_type":"null","other_rooms":"null","parking_type":"CARPORT","parking_spaces_count":"1.0","plumbing_fixtures_count":"null","pool_type":"null","quality":"C+","roof_material_type":"ASPHALT","roof_style_type":"null","sewer_type":"null","water_type":"null"}},
        schools: [],
        schoolsForDev: [
          {
            gsRating: '9',
            name: 'Cooper Elementary School',
            type: 'public',
            gradeRange: 'K to 4',
            desc: 'Public | K to 4 | Serves this home',
            distance: '3.2 mi',
            distanceText: 'distance',
          },
          {
            gsRating: '6',
            name: 'Old High Middle School',
            type: 'public',
            gradeRange: '5 to 6',
            desc: 'Public | 5 to 6 | Serves this home',
            distance: '7.6 mi',
            distanceText: 'distance',
          },
          {
            gsRating: '8',
            name: 'Washington Junior High School',
            type: 'public',
            gradeRange: '7 to 8',
            desc: 'Public | 7 to 8 | Serves this home',
            distance: '8.1 mi',
            distanceText: 'distance',
          },
          {
            gsRating: '8',
            name: 'Bentonville High School',
            type: 'public',
            gradeRange: '9 to 12',
            desc: 'Public | 9 to 12 | Serves this home',
            distance: '9.4 mi',
            distanceText: 'distance',
          },
        ],
        walkscore: null,
        walkscoreForDev: {
          status: 1,
          walkscore: 19,
          description: 'Car-Dependent',
          updated: '2020-11-01 13:42:33.213643',
          logo_url: 'https://cdn.walk.sc/images/api-logo.png',
          more_info_icon: 'https://cdn.walk.sc/images/api-more-info.gif',
          more_info_link: 'https://www.redfin.com/how-walk-score-works',
          ws_link: 'https://www.walkscore.com/score/9-NORWOOD-LN-BELLA-VISTA-AR-72714-1849/lat=36.481077/lng=-94.247209/?utm_source=honely.com&utm_medium=ws_api&utm_campaign=ws_api',
          help_link: 'https://www.redfin.com/how-walk-score-works',
          snapped_lat: 36.4815,
          snapped_lon: -94.2465,
          bike: {
            score: 16,
            description: 'Somewhat Bikeable',
          },
          transit: {
            score: 100,
            description: "Rider's Paradise",
            summary: '115 nearby routes: 103 bus, 6 rail, 6 other',
          },
        },
        forecast: null,
        // eslint-disable-next-line
        forecastForDev: {"zipcode":"10021","state":"NY","property_forecast":{"fips":"36061","apn":"01384-1108","address":"15 E 69 ST # 9A NEW YORK NY 10021 4905","latitude":"40.770245","longitude":"-73.96684","list_price":"3090000","valuation":"3030022","appraised_value":"3088574","beds_count":"2","baths":"2","realtor":"Schwarz and Shah Reality","property_status":"For Sale","total_area_sq_ft":"3023","percentage_change_forecasts":[{"year":"May 2022","change":"5.61"},{"year":"May 2023","change":"7.48"},{"year":"May 2024","change":"9.13"}],"value_change_forecasts":[{"year":"May 2022","change":"3200000"},{"year":"May 2023","change":"3256800"},{"year":"May 2024","change":"3306809"}],"property_valued_compared_to_zipcode":"57.79"},"neighborhood":{"percentage_change_forecasts":[{"year":"May 2022","change":"-92.70"},{"year":"May 2023","change":"-91.65"},{"year":"May 2024","change":"-90.61"}],"value_change_forecasts":[{"year":"May 2022","change":"140248.85"},{"year":"May 2023","change":"160248.85"},{"year":"May 2024","change":"180248.85"}],"past_percentage_change":[{"year":"May 2020","change":"93.82"},{"year":"May 2019","change":"94.02"},{"year":"May 2021","change":"94.22"}],"zipcode_growth_state_ranking_forecasts":[{"year":"May 2021","rank":"10"}],"zipcode_growth_national_ranking_forecasts":[{"year":"May 2021","rank":"54"}],"total_state_rank":"256","total_national_rank":"2265","competitive_score":"59","competition_statements":"Some homes get multiple offers|The average homes sell for about 2% below list price and go pending in around 48 days.|Hot homes can sell for around list price and go pending in around 23 days.","last_30_days_median_list_price":"1503123.23","last_30_days_median_square_feet":"1200.45","last_30_days_median_sale_list":"1694313.89","last_30_days_total_homes_sold":"30"},"moving_trends":{"percentage_change_forecasts":[{"year":"May 2022","change":"1056383"}],"percentage_change_comparison_forecasts":[{"year":"May 2022","change":"24.34"}],"past_percentage_changes":[{"year":"May 2020","change":"-7.34"}],"past_percentage_changes_comparison":[{"year":"May 2022","rank":"53"}]}},
        mySponsoredListings: [],
        errorMessage: null,
        errorAddress: null,
        loading: false,
      }
    },

    computed: {
      ...mapState('auth', ['currentUser']),
      ...mapGetters('listings', ['favoriteListings']),
      ...mapGetters('auth', ['loggedIn', 'username', 'vxAuth', 'vxAuthDependent', 'isCognitoUserLoggedIn', 'cognitoUser']),
      listhubTrackerUrl: function () {
        return 'https://tracking.listhub.net/tracker?mp=' + encodeURIComponent('M-5383') + '&ev=' + encodeURIComponent('DETAIL_PAGE_VIEWED') + '&et=' + encodeURIComponent(Date.now()) + '&v=' + encodeURIComponent('3') + '&ep=' + encodeURIComponent(window.location.href) + '&lkey=' + encodeURIComponent(this.listing.address.listing_key) + '&clid=' + encodeURIComponent('123456') + '&ua=' + encodeURIComponent(navigator.userAgent)
      },
      listhubTrackerUrl2: function () {
        return 'https://tracking.listhub.net/tracker?mp=' + encodeURIComponent('M-5383') + '&ev=' + encodeURIComponent('AGENT_OFFICE_EMAIL_SENT') + '&et=' + encodeURIComponent(Date.now()) + '&v=' + encodeURIComponent('3') + '&ep=' + encodeURIComponent(window.location.href) + '&lkey=' + encodeURIComponent(this.listing.address.listing_key) + '&clid=' + encodeURIComponent('123456') + '&ua=' + encodeURIComponent(navigator.userAgent)
      },
      isRealtor: function () {
        /* 
        if (this.currentUser) {
          return this.$store.getters['auth/permissions'].indexOf('sponsor-property') !== -1
        } else {
          return false
        }
        */
      },
      isSponsored: function () {
        return this.listing && this.listing.is_sponsored
      },
      isMySponsor: function () {
        var me = this
        const index = this.mySponsoredListings.findIndex(function (x) {
          return x.fips === me.fips && x.apn === me.apn
        })
        return index !== -1
      },

      hasTaxData () {
        return this.listing && this.listing.tax && this.listing.tax.length > 0
      },
      hasSalesData () {
        return this.listing && this.listing.sale_history && this.listing.sale_history.length > 0
      },
      hasTaxAndSalesData () {
        return this.hasTaxData && this.hasSalesData
      },
    },

    watch: {
      $route (to, from) {
        
        this.fips = this.$route.params.fips
        this.apn = this.$route.params.apn
        console.log('vx: lalala1')
        if (isNaN(this.$route.params.search_id)) {
          this.listing_key = this.$route.params.search_id
        } else {
          this.property_id = this.$route.params.search_id
        }

        if (this.query !== null) {
          this.query = this.$route.query.address
        } else {
          let currentAddress = this.getURLParameterByName('address', window.location.href)
          if(currentAddress !== null && currentAddress !== 'null') {
            this.query = currentAddress
          } else {
            this.query = ''
          }
        }
        this.load()
      },
    },
    updated () {
      // this.getImage()
    },
    mounted () {
      this.fips = this.$route.params.fips
      this.apn = this.$route.params.apn
      console.log(this.$route)

      if (isNaN(this.$route.params.search_id)) {
        this.listing_key = this.$route.params.search_id
      } else {
        this.property_id = this.$route.params.search_id
      }

      this.address = this.$route.query.address

      console.log('property id:', this.propertyId)
      console.log('listing key: ', this.listing_key)
    
      this.getImage()
      this.load()
      console.log('vx: screen', this.$vuetify.breakpoint.name)
    },
    created () {
      this.fips = this.$route.params.fips
      this.apn = this.$route.params.apn
      console.log('vx: lalala3')

      if (isNaN(this.$route.params.search_id)) {
        this.listing_key = this.$route.params.search_id
      } else {
        this.property_id = this.$route.params.search_id
      }

      if (this.query !== null) {
        this.query = this.$route.query.address
        this.listing_key = this.$route.query.listing_key
      } else {
        let currentAddress = this.getURLParameterByName('address', window.location.href)
        // console.log('current: ' + currentAddress)
        if(currentAddress !== null && currentAddress !== 'null') {
          this.query = currentAddress
        } else {
          this.query = ''
        }
      }
      if (this.$useDevVariables) {
        this.listing = this.listingForDev
        this.schools = this.schoolsForDev
        this.walkscore = this.walkscoreForDev
        this.forecast = this.forecastForDev
        this.user = {
          user_id: null,
          first_name: 'Sample',
          last_name: 'Sample',
          email: null,
          phone_number: null,
          lookup_count: null,
          membership_type: null,
        }
        Scriptjs('https://maps.googleapis.com/maps/api/js?key=' + this.$mapsKey, () => {
          this.initMap()
        })
      } else {
        if (this.$store.getters['auth/loggedIn']) {
          this.$store.dispatch('listings/getFavorites')
            .then(() => {
              // this.load()
            })
        } else {
          // this.load()
        }

        bus.$on('successfulLogin', (data) => {
          // if (this.$store.getters['auth/loggedIn']) {
          //   this.$store.dispatch('listings/getFavorites')
          //     .then(() => {
          //       this.load()
          //     })
          // } else {
          //   this.load()
          // }
        })
      }
    },

    // updated () {
    //   this.$store.dispatch('auth/checkIsCognitoUserLoggedIn')
    // },
    // mounted () {
    //   this.$store.dispatch('auth/checkIsCognitoUserLoggedIn')
    // },

    methods: {
      toTitleCase (str) {
        return str.toLowerCase().split(' ').map(function (word) {
          return (word.charAt(0).toUpperCase() + word.slice(1))
        }).join(' ')
      },
      submitLead () {
        if (!this.listing.list_agent_information.list_agent_email) {
          this.leadFormErrorMessage = 'Sorry! This form cannot be submitted.'
          setTimeout(() => {
            this.leadFormErrorMessage = ''
          }, 3000)
        } else if (!this.leadName || !this.leadEmail || !this.leadPhone || !this.leadMessage) {
          this.leadFormErrorMessage = 'Please enter all the fields!'
          setTimeout(() => {
            this.leadFormErrorMessage = ''
          }, 3000)
        } else {
          const params = {
            name: this.leadName,
            message: this.leadMessage,
            email: this.leadEmail,
            phone_number: this.leadPhone,
            agent_email: this.listing.list_agent_information.list_agent_email,
          }
          axios.post('https://api.honely.com/lookup-test/agent_contact', params)
          .then(() => {
            this.leadFormErrorMessage = ''
            this.successMessage = 'Submitted successfully!'
            setTimeout(() => {
            this.successMessage = ''
          }, 3000)
          // axios.get('https://tracking.listhub.net/tracker', {
          //   params: {
          //     mp: encodeURIComponent('M-5383'),
          //     ev: encodeURIComponent('AGENT_OFFICE_EMAIL_SENT'),
          //     et: encodeURIComponent(Date.now()),
          //     v: encodeURIComponent('3'),
          //     ep: encodeURIComponent(window.location.href),
          //     lkey: encodeURIComponent(this.listing.address.listing_key),
          //     clid: encodeURIComponent('123456'),
          //     ua: encodeURIComponent(navigator.userAgent)
          //   },
          // })
          this.agentOfficeEmailFlag = true
          })
          .catch((error) => {
            this.leadFormErrorMessage = error
            setTimeout(() => {
              this.leadFormErrorMessage = ''
            }, 3000)
          })
        }
      },
      isNumber: function (evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      getURLParameterByName(name, url) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(url)
        if (!results) return null
        if (!results[2]) return ''
        return decodeURIComponent(results[2].replace(/\+/g, ' '))
      },
      getImage: function () {
        const toDataURL = url => fetch(url)
          .then(response => response.blob())
          .then(blob => new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          }))
        if (this.listing) {
          toDataURL(this.listing.image)
          .then(dataUrl => {
            if (dataUrl === constants.noImage2) {
              this.listing.image = constants.placeHolder
            }
            // this.img = this.getImgBaseUrl()
          })
          .catch(() => {
            this.img = this.placeHolder
          })
        }
      },
      getImage2: function (pika, y) {
        const toDataURL = url => fetch(url)
          .then(response => response.blob())
          .then(blob => new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          }))
        toDataURL(pika)
        .then(dataUrl => {
          // if (dataUrl === constants.noImage2) {
          //   this.listing.image = constants.placeHolder
          // }
          // this.img = this.getImgBaseUrl()
          console.log('vx: cynda', dataUrl)
        })
        .catch(() => {
          console.log('vx: cynda2')
          this.listing.images[y] = this.placeHolder2
        })
      },
      formatCount (value) {
        if (!parseInt(value)) {
          return '--'
        } else {
          return String(parseFloat(value))
        }
      },
      formatArea (value) {
        if (value === null) {
          return '--'
        } else {
          return value.substring(1)
        }
      },
      getHomeSize (value) {
        if (value === null) {
          return '--'
        } else if (value.split('/')[0] === '') {
          return '--'
        } else {
          return value.split('/')[0].split('.')[0]
        }
      },
      getLotSize (value) {
        if (value === null) {
          return '--'
        } else if (value.split('/')[1] === '') {
          return '--'
        } else {
          return value.split('/')[1]
        }
      },
      scrollTo (theID) {
        var element = document.getElementById(theID)
        var headerOffset = 60
        var elementPosition = element.getBoundingClientRect().top
        var offsetPosition = elementPosition - headerOffset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })
      },
      load () {
        // if (this.fips && this.apn) {
        if (this.$useDevVariables) {
          this.user = {
            user_id: null,
            first_name: 'Sample',
            last_name: 'Sample',
            email: null,
            phone_number: null,
            lookup_count: null,
            membership_type: null,
            blocked: null,
           }
        } else {
          // console.log('user', this.$store.getters['auth/cognitoUser'])
          // console.log('this.$store.getters[\'auth/isCognitoUserLoggedIn\']', this.$store.getters['auth/isCognitoUserLoggedIn'])
          if (this.$store.getters['auth/isCognitoUserLoggedIn']) {
            axios.get('https://api.honely.com/lookup/user_profile', {
              params: {
                email: this.$store.getters['auth/cognitoUser'].attributes.email,
              },
            }).then((response) => {
              this.user = response.data
              // console.log(this.user)
            }).catch((error) => {
              console.log('[ERROR] Failed to fetch user data',error)
              console.log(error.response.data.errorMessage)
            })
          }
        }
        setTimeout(()=>{
          let searchId = ''
            if (this.listing_key) {
              searchId = this.listing_key
            } else if (this.property_id) {
              searchId = this.property_id
            }
            // axios.get('https://api.honely.com/search/listing', {
          axios.get('https://listhub.honely.com/locate/listhub_listing', {
            params: {
              // apn: this.apn,
              // fips: this.fips,
              // listing_key: this.listing_key,
              user_id: this.useridentification,
              search_id: searchId,
            },
          }).then((response) => {
            // console.log('test ------------------')
            // console.log(response.data)
            this.listing = response.data

            if (this.listing_key) {
              this.listing.images = []
              axios.get('https://listhub.honely.com/locate/listhub-images-exist?id=' + this.listing_key)
              .then((response) => {
                console.log('vx: neten api response', response.data.exists)
                if (response.data.exists) {
                  for (let x = 1; x <= this.listing.address.photos_count; x++) {
                    // axios.get('https://listhub-property-images.s3.amazonaws.com/' + this.listing.address.listing_key + '_' + x.toString() + '.jpg')
                    // .then(() => {
                    //   this.listing.images.push('https://listhub-property-images.s3.amazonaws.com/' + this.listing.address.listing_key + '_' + x.toString() + '.jpg')
                    // })
                    // .catch((error) => {
                    //   console.log('vx: going to put placeholder2 because...', error)
                    //   this.listing.images.push(this.placeHolder2)
                    // })
                    this.listing.images.push('https://listhub-property-images.s3.amazonaws.com/' + this.listing.address.listing_key + '_' + x.toString() + '.jpg')
                    // this.listing.images.push('https://listhub-property-images.s3.amazonaws.com/' + this.listing.address.listing_key + '_' + x.toString() + '.jpg')
                    // this.getImage2(this.listing.images[x-1], x-1)
                    if(x === 5 && this.listing.address.zip_code !== '33487') {
                      break
                    }
                  }
                } else {
                  this.listing.images.push(this.placeHolder2)
                }
              })

              // if (this.listing.images.length === 0) {
              //   console.log('vx: heehee')
              //   this.listing.images[0] = this.placeHolder
              // }
              /*for (let y = 0; y < this.listing.images.length; y++) {
                // console.log('vx: dragonite', this.listing.images)
                // this.getImage2(this.listing.images[y], y)
                const img = new Image()
                img.src =  this.listing.images[y]
                if (this.item.listhubImage && img.onerror) {
                  // console.log('vx: bulba')
                  this.listing.images[y] = this.placeHolder2
                }
              }*/
            } else {
              this.listing.image = 'https://maps.googleapis.com/maps/api/streetview?size=640x640&location=' + this.listing.address.latitude + '' +
                ',' + this.listing.address.longitude + '+&fov=90&source=outdoor&key=' + this.mapsKey
            }

            if (response.data.address.property_id) {
              this.property_id = response.data.address.property_id
            }

            if (this.listing.structure.year_built && this.listing.structure.year_built.includes('.')) {
              this.listing.structure.year_built = this.listing.structure.year_built.slice(0,-2)
            }
            if (this.listing.structure.total_area_sq_ft && this.listing.structure.total_area_sq_ft.includes('.')) {
              this.listing.structure.total_area_sq_ft = this.listing.structure.total_area_sq_ft.slice(0,-2)
            }
            if (this.listing.structure.stories && this.listing.structure.stories.includes('.')) {
              this.listing.structure.stories = this.listing.structure.stories.slice(0,-2)
            }
            if (this.listing.structure.parking_spaces_count && this.listing.structure.parking_spaces_count.includes('.')) {
              this.listing.structure.parking_spaces_count = this.listing.structure.parking_spaces_count.slice(0,-2)
            }
            /*this.listing.images = []
            for (let x = 1; x <= this.listing.address.photos_count; x++) {
              this.listing.images.push('https://listhub-property-images.s3.amazonaws.com/' + this.listing.address.listing_key + '_' + x.toString() + '.jpg')
              if(x === 10) {
                break
              }
            }*/
          
          //   axios.get('https://tracking.listhub.net/tracker', {
          //   params: {
          //     mp: encodeURIComponent('M-5383'),
          //     ev: encodeURIComponent('DETAIL_PAGE_VIEWED'),
          //     et: encodeURIComponent(Date.now()),
          //     v: encodeURIComponent('3'),
          //     ep: encodeURIComponent(window.location.href),
          //     lkey: encodeURIComponent(this.listing.address.listing_key),
          //     clid: encodeURIComponent('123456'),
          //     ua: encodeURIComponent(navigator.userAgent)
          //   },
          // })
            this.loading = false
            Scriptjs('https://maps.googleapis.com/maps/api/js?key=' + this.$mapsKey, () => {
              this.initMap()
            })

            this.getSchoolData()
            this.getWalkScore()
            this.getForecast()
            this.getRelatedListings()
            // this.getMySponsoredListings()
          })
            .catch((error) => {
              console.log('vx: error is', error)
              this.errorMessage = error.response.data.errorMessage
              this.errorAddress = error.response.data.address
              this.loading = false
              this.$router.push('/listingNotFound')
            })

          /*if (this.property_id) {
          this.errorMessage = null
          this.errorAddress = null
          this.loading = true
          var useridentification = null
          if (this.user) {
            useridentification = this.user.user_id
          }
          console.log('vx: listing_key is', this.listing_key)
          if (!this.listing_key) {
            // axios.get('https://api.honely.com/search/listing', {
          axios.get('https://api.honely.com/lookup/listing', {
            params: {
              // apn: this.apn,
              // fips: this.fips,
              property_id: this.property_id,
              user_id: useridentification,
            },
          }).then((response) => {
            this.listing = response.data
            const tempImages = this.$store.getters['listings/tempImages'](this.fips + '/' + this.apn)
            if (tempImages) {
              this.listing.tempImages = tempImages
            }

            // if (response.data.schools && response.data.schools.schools) {
            //   this.schools = response.data.schools.schools
            // }
            // if (!Array.isArray(this.schools)) {
            //   this.schools = [this.schools]
            // }

            // this.schools = this.schools.splice(0, 10)

            // this.schools.forEach(function (school) {
            //   console.log('vx: school object is', school)
            //   // school.distance = school.distance.toFixed(2)
            //   school.distanceText = 'mi'
            // })

            // this.walkscore = response.data.walkscore

            if (tempImages) {
              this.listing.image = '/apartment_temp_images/' + tempImages[0]
            } else {
              this.listing.image = 'https://maps.googleapis.com/maps/api/streetview?size=640x640&location=' + this.listing.address.latitude + '' +
                ',' + this.listing.address.longitude + '+&fov=90&source=outdoor&key=' + this.mapsKey
              // console.log(this.listing.image)
            }
            this.loading = false
            this.getImage()

            Scriptjs('https://maps.googleapis.com/maps/api/js?key=' + this.$mapsKey, () => {
              this.initMap()
            })

            this.getSchoolData()
            this.getWalkScore()
            this.getForecast()
            this.getRelatedListings()
            // this.getMySponsoredListings()
          })
            .catch((error) => {
              this.errorMessage = error.response.data.errorMessage
              this.errorAddress = error.response.data.address
              this.loading = false
            })
          } else {
            let searchId = ''
            if (this.listing_key) {
              searchId = listing_key
            } else if (this.property_id) {
              searchId = this.property_id
            }
            // axios.get('https://api.honely.com/search/listing', {
          axios.get('https://listhub.honely.com/locate/listhub_listing', {
            params: {
              // apn: this.apn,
              // fips: this.fips,
              // listing_key: this.listing_key,
              user_id: useridentification,
              search_id: searchId,
            },
          }).then((response) => {
            this.listing = response.data
            if (this.listing.structure.year_built && this.listing.structure.year_built.includes('.')) {
              this.listing.structure.year_built = this.listing.structure.year_built.slice(0,-2)
            }
            if (this.listing.structure.total_area_sq_ft && this.listing.structure.total_area_sq_ft.includes('.')) {
              this.listing.structure.total_area_sq_ft = this.listing.structure.total_area_sq_ft.slice(0,-2)
            }
            if (this.listing.structure.stories && this.listing.structure.stories.includes('.')) {
              this.listing.structure.stories = this.listing.structure.stories.slice(0,-2)
            }
            if (this.listing.structure.parking_spaces_count && this.listing.structure.parking_spaces_count.includes('.')) {
              this.listing.structure.parking_spaces_count = this.listing.structure.parking_spaces_count.slice(0,-2)
            }
            this.listing.images = []
            for (let x = 1; x <= this.listing.address.photos_count; x++) {
              this.listing.images.push('https://listhub-property-images.s3.amazonaws.com/' + this.listing.address.listing_key + '_' + x.toString() + '.jpg')
              if(x === 10) {
                break
              }
            }
            if (this.listing.images.length === 0) {
              this.listing.images[0] = this.placeHolder
            }
            for (let y = 0; y < this.listing.images.length; y++) {
              this.getImage2(this.listing.images[y], y)
            }
            axios.get('https://tracking.listhub.net/tracker', {
            params: {
              mp: encodeURIComponent('M-5383'),
              ev: encodeURIComponent('DETAIL_PAGE_VIEWED'),
              et: encodeURIComponent(Date.now()),
              v: encodeURIComponent('3'),
              ep: encodeURIComponent(window.location.href),
              lkey: encodeURIComponent(this.listing.address.listing_key),
              clid: encodeURIComponent('123456'),
              ua: encodeURIComponent(navigator.userAgent)
            },
          })
            // this.console.log('vx: this.listing.images', this.listing.images)
            // const tempImages = this.$store.getters['listings/tempImages'](this.fips + '/' + this.apn)
            // if (tempImages) {
            //   this.listing.tempImages = tempImages
            // }

            // if (response.data.schools && response.data.schools.schools) {
            //   this.schools = response.data.schools.schools
            // }
            // if (!Array.isArray(this.schools)) {
            //   this.schools = [this.schools]
            // }

            // this.schools = this.schools.splice(0, 10)

            // this.schools.forEach(function (school) {
            //   console.log('vx: school object is', school)
            //   // school.distance = school.distance.toFixed(2)
            //   school.distanceText = 'mi'
            // })

            // this.walkscore = response.data.walkscore

            // if (tempImages) {
            //   this.listing.image = '/apartment_temp_images/' + tempImages[0]
            // } else {
            //   this.listing.image = 'https://maps.googleapis.com/maps/api/streetview?size=640x640&location=' + this.listing.address.latitude + '' +
            //     ',' + this.listing.address.longitude + '+&fov=90&source=outdoor&key=' + this.mapsKey
            //   // console.log(this.listing.image)
            // }
            this.loading = false
            // this.getImage()

            Scriptjs('https://maps.googleapis.com/maps/api/js?key=' + this.$mapsKey, () => {
              this.initMap()
            })

            this.getSchoolData()
            this.getWalkScore()
            this.getForecast()
            this.getRelatedListings()
            // this.getMySponsoredListings()
          })
            .catch((error) => {
              console.log('vx: error is', error)
              this.errorMessage = error.response.data.errorMessage
              this.errorAddress = error.response.data.address
              this.loading = false
            })
          }
        } */
        },500)
        // if (this.property_id) {
        //   this.errorMessage = null
        //   this.errorAddress = null
        //   this.loading = true
        //   // axios.get('https://api.honely.com/search/listing', {
        //   axios.get('https://api.honely.com/lookup/listing', {
        //     params: {
        //       // apn: this.apn,
        //       // fips: this.fips,
        //       property_id: this.property_id,
        //       user_id: this.user.user_id,
        //     },
        //   }).then((response) => {
        //     this.listing = response.data
        //     const tempImages = this.$store.getters['listings/tempImages'](this.fips + '/' + this.apn)
        //     if (tempImages) {
        //       this.listing.tempImages = tempImages
        //     }

        //     // if (response.data.schools && response.data.schools.schools) {
        //     //   this.schools = response.data.schools.schools
        //     // }
        //     // if (!Array.isArray(this.schools)) {
        //     //   this.schools = [this.schools]
        //     // }

        //     // this.schools = this.schools.splice(0, 10)

        //     // this.schools.forEach(function (school) {
        //     //   console.log('vx: school object is', school)
        //     //   // school.distance = school.distance.toFixed(2)
        //     //   school.distanceText = 'mi'
        //     // })

        //     // this.walkscore = response.data.walkscore

        //     if (tempImages) {
        //       this.listing.image = '/apartment_temp_images/' + tempImages[0]
        //     } else {
        //       this.listing.image = 'https://maps.googleapis.com/maps/api/streetview?size=640x640&location=' + this.listing.address.latitude + '' +
        //         ',' + this.listing.address.longitude + '+&fov=90&source=outdoor&key=' + this.mapsKey
        //     }
        //     this.loading = false

        //     Scriptjs('https://maps.googleapis.com/maps/api/js?key=' + this.$mapsKey, () => {
        //       this.initMap()
        //     })

        //     this.getSchoolData()
        //     this.getWalkScore()
        //     this.getForecast()
        //     this.getRelatedListings()
        //     // this.getMySponsoredListings()
        //   })
        //     .catch((error) => {
        //       this.errorMessage = error.response.data.errorMessage
        //       this.errorAddress = error.response.data.address
        //       this.loading = false
        //     })
        // }
      },
      getSchoolData () {
        if (this.listing.address.latitude && this.listing.address.longitude) {
          axios.get('https://api.honely.com/lookup/great_schools', {
            params: {
              lat: this.listing.address.latitude,
              lon: this.listing.address.longitude,
            },
          }).then((response) => {
            this.schools = response.data.schools
            if (!Array.isArray(this.schools)) {
              this.schools = [this.schools]
            }

            this.schools = this.schools.splice(0, 10)

            this.schools.forEach(function (school) {
              school.distance = school.distance.toFixed(2)
              school.distanceText = 'mi'
            })
          })
        }
      },
      getWalkScore () {
        if (this.listing.address.street_name && this.listing.address.street_suffix && this.listing.address.city && this.listing.address.state && this.listing.address.zip_code && this.listing.address.latitude && this.listing.address.longitude) {
          axios.get('https://api.honely.com/lookup/walk_score', {
            params: {
              address: this.listing.address.street_name + this.listing.address.street_suffix + ',' + this.listing.address.city + ',' + this.listing.address.state + this.listing.address.zip_code,
              lat: this.listing.address.latitude,
              lon: this.listing.address.longitude,
            },
          }).then((response) => {
            this.walkscore = response.data
            // console.log(this.walkscore)
          })
        }
      },
      getForecast () {
        // if (this.fips && this.apn) {
        if (this.property_id) {
          if (this.property_id.includes('.')) {
            this.property_id = this.property_id.slice(0,-2)
          }
          // axios.get('https://api.honely.com/search/forecast', {
          // axios.get('https://api.honely.com/lookup/forecast', {
          axios.get('https://listhub.honely.com/locate/listhub_forecast', {
            params: {
              // apn: this.apn,
              // fips: this.fips,
              property_id: this.property_id,
              // user_id: this.user.user_id,
            },
          }).then((response) => {
            this.forecast = response.data
          })
        }
      },
      getRelatedListings () {
        // axios.get('https://api.honely.com/search/listings', {
          if (this.listing.address.property_id.includes('.')) {
            this.listing.address.property_id = this.listing.address.property_id.slice(0,-2)
          }
        axios.get('https://api.honely.com/lookup/comparable_homes?property_id=' + this.listing.address.property_id, {
          params: {
            // propertyId: this.listing.propertyId,
            // address: this.listing.address.zip_code,
            // order_by: this.sortBy,
            // order_dir: this.sortOrder,
          },
        }).then((response) => {
          this.listings = []

          response.data.rows.forEach(function (row) {
            if (this.listings.length < 3 && (row.apn !== this.apn || row.fips !== this.fips)) {
              row.appraisal = row.current_value
              row.beds_count = row.bedrooms
              row.baths = row.bathrooms
              row.latitude = row.situslatitude
              row.longitude = row.situslongitude
              const tempImages = this.$store.getters['listings/tempImages'](row.fips + '/' + row.apn)
              if (tempImages) {
                row.tempImages = tempImages
              }
              this.listings.push(row)
            }
          }, this)
        })
      },
      getMySponsoredListings () {
        axios
          .get('/api/v1/my-sponsored-listings', {
            headers: {
              Authorization: 'Bearer ' + this.currentUser,
            },
          })
          .then((response) => {
            const data = response.data

            this.mySponsoredListings = data.rows
          })
      },
      initMap () {
        this.map = new google.maps.Map(document.getElementById('listing-map'), {
          center: {
            lat: parseFloat(this.listing.address.latitude),
            lng: parseFloat(this.listing.address.longitude),
          },
        })

        const me = this

        google.maps.event.addListener(me.map, 'zoom_changed', function () {
          google.maps.event.addListener(me.map, 'bounds_changed', function (event) {
            if (this.getZoom() > 15) {
              // Change max/min zoom here
              this.setZoom(15)
              this.initialZoom = false
            }
          })
        })

        const marker = new google.maps.Marker({
          position: { lat: parseFloat(this.listing.address.latitude), lng: parseFloat(this.listing.address.longitude) },
          // label: this.listing.address.formatted_street_address,
          // labelOrigin: new google.maps.Point(9, 9),
          map: this.map,
        })

        var bounds = new google.maps.LatLngBounds()
        bounds.extend(marker.getPosition())
        this.map.fitBounds(bounds)
      },
      formatPrice (value) {
        // let val = (value/1).toFixed(2).replace('.', ',')
        if (value) {
          value = value.toString().split('.')[0]
          value = parseInt(value)
          value = (value % 100 >= 50) ? Math.ceil(value / 100) * 100 : Math.floor(value / 100) * 100
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return '--'
        }
      },
      schoolDescription (school) {
        const description = []

        if (school.type) {
          description.push(school.type.charAt(0).toUpperCase() + school.type.slice(1))
        }
        if (school.level) {
          description.push(school.level)
        }

        // Serves this home?

        return description.join(' | ')
      },
      sponsorListing () {
        if (this.fips && this.apn) {
          axios.post('/api/v1/sponsor-listing',
                     {
                       fips: this.fips,
                       apn: this.apn,
                     },
                     {
                       headers: {
                         Authorization: 'Bearer ' + this.currentUser,
                       },
                     })
            .then(() => {
              this.load()
            })
        }
      },
      isFavorite: function (listing) {
        
        // console.log('vx: the size of favoriteListings prop is', this.favoriteListings.length)
        const exists = this.favoriteListings.find(function (x) {  //if favoriteListings contains an element whose fips and apn are same as this property's, then return true
        // console.log('vx: finding whether this listing is in favoriteListings prop, from Listing.vue')
        // console.log('vx: x.fips is'+ x.fips+ ' listing.address.fips is ' + listing.address.fips+ ' x.apn is ' + x.apn+ ' listing.address.apn is '+listing.address.apn)
          return x.fips === listing.address.fips && x.apn === listing.address.apn
        })
        // console.log('vx: exists here is ', exists)
        return exists
      },
      toggleFavorite: function (listing) {
        console.log('vx: auth/isCognitoUserLoggedIn in togglefav (Listing.vue) is', this.$store.getters['auth/isCognitoUserLoggedIn'])
        if (this.$store.getters['auth/isCognitoUserLoggedIn']) {
          if (!(!this.isFavorite(listing) && this.favoriteListings.length == 5)) {
          const payload = {
          property_id: listing.address.property_id,
          apn: listing.address.apn,
          fips: listing.address.fips,
          user_id: this.user.user_id,
          address: listing.address.full_address,
          appraisal: listing.valuation.appraisal,
        } 
          console.log('vx: payload inside toggleFavorite is', payload)
          this.$store.dispatch('listings/toggleFavorite', payload)
          } else {
            bus.$emit('showError', { message: 'Cannot have more than 5 favorite listings!' })
          }
        } else {
          bus.$emit('showError', { message: 'Please log in or create an account to add this to your favorites' })
        }
      },
      editListingInfo: function () {
        console.log('edit listing info')
      },
    },
  }
</script>

<style lang="sass">
  #listing
    border-top: 4px solid $color-orange
    min-height: 1000px

    #listing-div

      .v-btn
        font-weight: 600

        .sponsor-btn
          box-shadow: none

        .v-icon
          font-size: 1rem

      .white-buttons
        .v-icon
          padding-right: 6px

      .squash-buttons

        .v-btn
          color: white
          background-color: $color-squash

        .v-icon
          padding-left: 6px

      .map-container

      .sidebar
        text-align: center
        color: $color-gray-dk

      .sidebar-heading
        font-size: 20px !important
        line-height: 24px

      iframe
        border: 1px solid $color-gray-lt !important

      .listing-subheader
        padding-left: 0
        height: auto
        margin: 8px 0

      .listing-overview
        border-color: $color-emerald
        height: 250px

        .homecontainer

          .card-pricing
            display: block
            font-size: 27px
            font-family: $body-font-family
            font-weight: 600
            line-height: 27px

            .pricecat
              font-size: 15px

            .price2
              color: $color-emerald
              display: flex
              align-items: center
              justify-content: space-between

              button
                background-color: #ed2800 !important

                i
                  font-size: 15px
                  padding-left: 3px

          .v-btn
            background-color: $color-emerald
            color: white
            font-weight: 600
            letter-spacing: 0.04em

            .v-icon
              font-size: 1.5rem

          .btn-forecast
            float: right

          h3
            span
              font-size: 1rem
              color: $color-gray-med
              padding: 0 6px

          .tool-buttons

            .v-btn
              background-color: $color-gray-shadow
              height: 40px

              .v-icon
                padding: 0

    .background-gray
      background-color: $color-gray-vlt

    .band-header
      border-bottom: 2px solid $color-emerald

    table
      width: 100%
      border-collapse: collapse
      table-layout: fixed

      tr
        margin: 0

        th
          background-color: $color-gray-shadow
          color: white
          padding: 4px 20px
          text-align: left
          word-wrap: break-word

        td
          padding: 4px 0 10px 0
          margin: 0
          background-color: white
          word-wrap: break-word

    table.lined-table

      tr:nth-child(odd)
        background-color: white
        margin: 0

      tr:nth-child(even)
        background-color: $color-gray-vlt !important
        margin: 0

      th
        background-color: transparent
        color: $color-squash
        border-bottom: 2px solid $color-gray-med
        word-wrap: break-word

      th.table-subspacer
        padding-top: 15px
        background-color: white
        word-wrap: break-word

      td
        padding: 4px 20px
        margin: 0
        border-bottom: 1px solid $color-gray-lt
        background-color: inherit
        word-wrap: break-word

      td:first-child
        border-left: 1px solid $color-gray-lt
        word-wrap: break-word

      td:last-child
        text-align: right
        font-weight: 600
        word-wrap: break-word

    .school-rating
      font-size: 16px
      padding: 0 !important

    .white-background
      background-color: white

    .small-type
      font-size: 12px
      line-height: 14px
      color: $color-gray-med

    .btn-squash.v-btn
      color: white
      background-color: $color-squash !important

    .header-btn
      height: 30px
      float: right
      font-family: $body-font-family
      font-size: 14px

  .listings-error
    padding: 10px
    background: rgb(255, 248, 225)
    border: 1px solid rgb(200, 130, 5)
</style>
<style>
.view-smart-search {
  margin-right: 30px;
}
.property-price-col {
  margin-top: 10px;
}
.white-buttons-container{
  display: flex;
  align-items: center;
  gap: 10px;
}
.top-smart-search-btn a {
  text-decoration: none;
}
.top-smart-search-btn button {
  background-color: #07871c !important;
  color: #ffffff !important;
  height: 50px !important;
}
.listing-disclaimer {
  color: grey;
  font-family: 'Avalon Medium', arial;
  font-size: 12px;
  text-align: center;
  margin-bottom: 0px !important;
}

@media (max-width: 1024px) {
   .top-smart-search-btn{
     padding-left: 12px;
    margin-top: 4px;
  }

}
@media (max-width: 960px) {
  #listing .white-buttons .v-btn {
    margin-bottom: 6px;
    font-size: 12px;
  }

  #listing .squash-buttons.text-center {
    text-align: left !important;
    margin-top: 3px;
    padding-top: 0;
  }

  #listing-overview-card {
    height: auto !important;
  }

  #listing-overview-card .btn-forecast {
    float: none !important;
    margin-bottom: 10px;
  }

  #listing-map {
    height: 300px;
  }

  .top-smart-search-btn, .white-buttons-container{
    padding-left: 12px;
  }
}
@media (max-width: 600px) {
  .property-price-col {
    margin-bottom: 10px;
  }
  #listing #listing-div .listing-overview .homecontainer .card-pricing .price2 {
    flex-direction: column;
    justify-content: start;
    align-items: initial;
  }
  #listing #listing-div .listing-overview .homecontainer .card-pricing .price2 div:first-of-type,
  #listing #listing-div .listing-overview .homecontainer .card-pricing .price2 button {
    display: block;
  }
  .v-application .pt-0 {
    padding: 12px 0 !important;
  }
  .top-smart-search-btn, .white-buttons-container{
    padding-left: 0px;
  }
}
</style>
<style>
.custom-tooltip {
    opacity: 1!important;
}
</style>
